<template>
  <d-container fluid>
    <d-row>
      <!-- Main Sidebar -->
      <main-sidebar :items="sidebarItems" />

      <d-col class="main-content offset-lg-2 offset-md-3 p-0" tag="main" lg="10" md="9" sm="12">

        <!-- Main Navbar -->
        <main-navbar />

        <d-alert class="alert-royal-blue" :show="show_alert" theme="danger" ref="the_alert" style="position:sticky;top:0;left:0;z-index:10000;" dismissible >
          <i class="fa fa-info mx-2"></i>
          <span id="warning">{{ error_msg }}</span> 
          - <a class="alert-link" @click="retry"><u>click to reload</u></a>
        </d-alert>

        <!-- Content -->
        <slot />
  <go-top
    :size="55"
    :right="200"
    :bottom="50"
    :bottom-gap="50"
    :z-index="100"
    fg-color="#fff"
    bg-color="#007bff"
    :radius="5"
    weight="bold"
    ripple-bg="rgba(0, 0, 0, .5)"
    :boundary="500"
    :max-width="0"
    :has-outline="false"
    box-shadow="5px 5px 5px rgba(0, 0, 0, .5)">
    TOP
  </go-top>        
        <!-- Main Footer -->
        <main-footer />
      </d-col>

    </d-row>
  </d-container>
</template>

<script>
//import getSidebarItems from '@/data/sidebar-nav-items';
import GoTop from '@inotom/vue-go-top';

// Main layout components
import MainNavbar from '@/components/layout/MainNavbar/MainNavbar.vue';
import MainSidebar from '@/components/layout/MainSidebar/MainSidebar.vue';
import MainFooter from '@/components/layout/MainFooter/MainFooter.vue';
import env from '../env.vue';

export default {
  name: 'analytics',
  components: {
    MainNavbar,
    MainSidebar,
    MainFooter,
    GoTop,
  },
  data() {
    return {
      sidebarItems: [],
      error_msg:'',
      show_alert:false,
    };
  },
  mounted(){
    if (this.$store.state.token=='')
        self.location='/sttaa.admin/login';
    else
        this.getMenuItems();
  },
  methods:{
    retry(){
      self.location="/sttaa.admin/";
    },
    show_error(msg){
      if (msg==undefined) return;
      this.$refs.the_alert.dismissed=false;
      this.show_alert=true;
      this.error_msg=msg;
    },
    getMenuItems(){
      this.axios.get( env.server+'/menu' ).then(
        resp=>{
          resp.data=JSON.parse(resp.data);
          this.sidebarItems=resp.data;
        }
      );
   }
  }
}
</script>

